var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySymbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7498 4.62036V7.43286C13.7498 9.77661 12.8748 10.7141 10.6873 10.7141H9.99982V8.63822C9.99982 6.29447 9.12482 5.35697 6.93732 5.35697H4.99982V4.62036C4.99982 2.27661 5.87482 1.33911 8.06232 1.33911H10.6873C12.8748 1.33911 13.7498 2.27661 13.7498 4.62036Z",
    stroke: "#B4B4B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8929 7.56677V10.3793C10.8929 12.723 10.0179 13.6605 7.83038 13.6605H5.20538C3.01788 13.6605 2.14288 12.723 2.14288 10.3793V7.56677C2.14288 5.22302 3.01788 4.28552 5.20538 4.28552H7.83038C10.0179 4.28552 10.8929 5.22302 10.8929 7.56677Z",
    fill: "#F8F8F8",
    stroke: "#B4B4B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySymbol);
export default __webpack_public_path__ + "static/media/copy-symbol.e5f79483cb3d662c42bb7c6b7aacef44.svg";
export { ForwardRef as ReactComponent };